var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chart',{staticClass:"chart",staticStyle:{"height":"38px","width":"38px","padding":"4px"},attrs:{"option":_vm.option,"autoresize":true}})}
var staticRenderFns = []

export { render, staticRenderFns }